import { ScheduleItem } from './billingTypes';
import { BillingType } from 'domain/shared/newProject';

export const InitiateBillingValidationSchema = {
  data: {
    type: 'array',
    required: true,
    forEach: {
      type: 'object',
      properties: {
        amount: {
          type: 'string',
          required: true,
          message: 'Amount is required',
        },
        plannedRegularHours: {
          type: 'number',
          required: {
            value: true,
            when: {
              $type: {
                in: [ScheduleItem.CUSTOM_PERIOD, ScheduleItem.CALENDAR_PERIOD],
              },
              $billingType: {
                eq: BillingType.PERIODIC_PREPAID,
              },
              $isDraft: {
                nin: [true, undefined],
              },
            },
          },
        },
        plannedOvertimeHours: {
          type: 'number',
          required: {
            value: false,
            when: {
              $type: {
                in: [ScheduleItem.CUSTOM_PERIOD, ScheduleItem.CALENDAR_PERIOD],
              },
              $billingType: {
                eq: BillingType.PERIODIC_PREPAID,
              },
              $isDraft: {
                nin: [true, undefined],
              },
            },
          },
        },
        previousPeriodAdjustmentHours: {
          type: 'number',
          required: {
            value: false,
            when: {
              $type: {
                in: [ScheduleItem.CUSTOM_PERIOD, ScheduleItem.CALENDAR_PERIOD],
              },
              $billingType: {
                eq: BillingType.PERIODIC_PREPAID,
              },
              $isDraft: {
                nin: [true, undefined],
              },
            },
          },
        },
        hours: {
          type: 'number',
          required: {
            value: true,
            when: {
              $billingType: {
                eq: BillingType.PERIODIC_POSTPAID,
              },
              $type: {
                in: [ScheduleItem.CUSTOM_PERIOD, ScheduleItem.CALENDAR_PERIOD],
              },
              $isDraft: {
                nin: [true, undefined],
              },
            },
          },
        },
      },
    },
  },
  note: {
    type: 'string',
    required: false,
  },
  startDate: {
    type: 'string',
    required: {
      value: true,
      when: {
        $billingType: {
          eq: BillingType.MILESTONE,
        },
        $isDraft: {
          nin: [true, undefined],
        },
      },
    },
  },
  endDate: {
    type: 'string',
    required: {
      value: true,
      when: {
        $billingType: {
          eq: BillingType.MILESTONE,
        },
        $isDraft: {
          nin: [true, undefined],
        },
      },
    },
  },
  serviceDetailsArtifactId: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isDraft: {
          nin: [true, undefined],
        },
      },
    },
  },
  reimbursementDocumentationArtifactIds: {
    type: 'array',
    maxSize: 10,
    required: false,
  },
};

export const MigrateBillingValidationSchema = {
  data: {
    type: 'array',
    required: true,
    forEach: {
      type: 'object',
      properties: {
        amount: {
          type: 'string',
          required: true,
          message: 'Amount is required',
        },
        hours: {
          type: 'number',
          required: {
            value: true,
            when: {
              $type: {
                in: [ScheduleItem.CUSTOM_PERIOD, ScheduleItem.CALENDAR_PERIOD],
              },
            },
          },
        },
      },
    },
  },
  note: {
    type: 'string',
    required: false,
  },
  billingRequestDate: {
    type: 'string',
    required: true,
    message: 'Billing request date is required',
  },
  artifactId: {
    type: 'array',
    maxSize: 1,
    required: false,
    message: 'Billing request artifact is required',
  },
};

export const billingRequestRejectValidationSchema = {
  reason: { type: 'string', required: true },
};
